import axios from "axios";
import { getAccessToken } from "../auth/auth.service";
import { ToastMessageType } from "primereact/toast";
import { toastRef } from "../components/Layout/Layout";
import ErrorUtilities from "../shared/Utilities/errorUtilities";

const axiosInstance = axios.create({
    baseURL: "/api/",
});

axiosInstance.interceptors.request.use(async (request) => {
    try {
        const token = await getAccessToken();
        request.headers = request.headers || {};
        request.headers["Authorization"] = `Bearer ${token}`;
    } catch (error) {
        console.error("Failed to attach token:", error);
    }
    return request;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            try {
                const newToken = await getAccessToken();
                originalRequest._retry = true;
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`
                return axios(originalRequest);
            } catch (refreshError) {
                console.error("Token refresh failed:", refreshError);
            }
        }
        error = extractError(error);
        return Promise.reject(error);
    }
);

const extractError = (error: any) => {
    if (axios.isCancel(error)) {
        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
        console.log(error.message);
    }
    else {

        ///Restituisce Null se l'errore non è di tipo MyArgumentException
        let toastMessage: ToastMessageType | null = ErrorUtilities.GetToastPropFromMyArgumentException(error);
        if (toastMessage) {
            toastRef.current?.show(toastMessage);
            /// setto isErrorShown per impedire che venga mostrato un secondo alert 
            error = { ...error, isErrorShown: true };
        }
    }
    return error;
}


export default axiosInstance;


// Istanza di Axios per chiamate non autenticate
export const axiosInstanceNoAuth = axios.create({
    baseURL: "/api/",
});